export function filterDailyRows(rows = [], selections = {}) {
  const { locations = [], providers = [], products = [], categories = [], fuelTypes = [] } = selections;
  return rows.filter((row) =>
    (locations.length === 0 || locations.includes(row.locationCode) || locations.includes(row.locationFilterKey || row.location || row.locationName)) &&
    (providers.length === 0 || providers.includes(row.provider)) &&
    (products.length === 0 || products.includes(row.productName)) &&
    (categories.length === 0 || (row.categoryId && categories.includes(row.categoryId))) &&
    (fuelTypes.length === 0 || (row.fuelTypeId && fuelTypes.includes(row.fuelTypeId)))
  );
}

export function hasDailyDisplayScope(selections = {}) {
  const { locations = [], providers = [], products = [], categories = [], fuelTypes = [] } = selections;
  return locations.length > 0 && providers.length > 0 &&
    (products.length > 0 || categories.length > 0 || fuelTypes.length > 0);
}

export function reconcileDailyLocationSelection({
  previous = [],
  optionIds = [],
  recommendedId = null,
  isSearching = false,
}) {
  if (previous.length > 0 && isSearching) return previous;
  if (previous.length > 0) return previous.filter((id) => optionIds.includes(id));
  if (recommendedId) return [recommendedId];
  return optionIds[0] ? [optionIds[0]] : [];
}
